import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["button", "panel"]
  static values = {
    active: { type: String, default: "visualization" }
  }

  connect() {
    this.show(this.activeValue)
  }

  switch(event) {
    this.show(event.currentTarget.dataset.panel)
  }

  show(name) {
    this.activeValue = name

    this.buttonTargets.forEach((button) => {
      const selected = button.dataset.panel === name
      button.setAttribute("aria-selected", selected ? "true" : "false")
      button.dataset.state = selected ? "active" : "inactive"
      button.tabIndex = selected ? 0 : -1
    })

    this.panelTargets.forEach((panel) => {
      const selected = panel.dataset.panel === name
      panel.classList.toggle("hidden", !selected)
      panel.setAttribute("aria-hidden", selected ? "false" : "true")
    })
  }
}
